import { UserRoleName } from 'gen/graphql-type'
import {
  User_ShipmentCsvPolicy_ShowFragment,
  User_ShipmentCsvPolicy_ShowSidebarFragment,
} from './fragment.gen-graphql'
import { Authorize, authorize } from '../authorize'

export const canShow: Authorize<User_ShipmentCsvPolicy_ShowFragment> = user => {
  return authorize(user, [
    UserRoleName.Operator,
    UserRoleName.SystemOperator,
    UserRoleName.Consignor,
    UserRoleName.DmhOperator,
  ])
}

export const canShowSidebar: Authorize<User_ShipmentCsvPolicy_ShowSidebarFragment> = user => {
  return authorize(user, [
    UserRoleName.Operator,
    UserRoleName.SystemOperator,
    UserRoleName.Consignor,
    UserRoleName.DmhOperator,
  ])
}
